import { useUnistyles, StyleSheet } from "react-native-unistyles";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { PressableScale } from "pressto";
import { Icon } from "@src/components/Icon";

type ContactItemProps = {
  isLastItem: boolean;
  title: string;
  subtitle?: string;
  onDelete: () => void;
  testID?: string;
};

export function ContactItem({ isLastItem, title, subtitle, onDelete, testID }: ContactItemProps) {
  const { theme } = useUnistyles();

  return (
    <View
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      py="md"
      px="xl"
      style={[styles.item, isLastItem && styles.lastItem]}
      testID={testID}
    >
      <View flex={1} mr="xl">
        <Text textStyle="sm/regular" numberOfLines={1}>
          {title}
        </Text>
        {subtitle && (
          <Text textStyle="xs/regular" color="textMuted" numberOfLines={1} mt="xs">
            {subtitle}
          </Text>
        )}
      </View>
      <PressableScale onPress={onDelete} accessibilityLabel="Delete contact">
        <Icon name="delete" color={theme.colors.status.error} />
      </PressableScale>
    </View>
  );
}

const styles = StyleSheet.create((theme) => ({
  item: {
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
  },
  lastItem: {
    borderBottomWidth: 0,
  },
}));
